import { SelfBillKind } from 'src/types/enums';

/** Client-safe: ride overviews and self-billing invoices each have their own finance page. */
export const SELF_BILL_LIST_PATHS: Record<`${SelfBillKind}`, string> = {
  [SelfBillKind.RideOverview]: '/internal/finance/ride-overviews',
  [SelfBillKind.SelfBilling]: '/internal/finance/self-billing',
};

export function selfBillPath(kind: `${SelfBillKind}`, id: string): string {
  return `${SELF_BILL_LIST_PATHS[kind]}/${id}`;
}
